import { createSlice } from "@reduxjs/toolkit";

export type ScreenStateType = {
  currentScreen: string;
  sites: any[];
  siteHours: string[];
  reloadPaymentPage: boolean;
};

const initialState: ScreenStateType = {
  currentScreen: "",
  sites: [],
  siteHours: [],
  reloadPaymentPage: false,
};

export const screenReducer = createSlice({
  name: "screenReducer",
  initialState: initialState,
  reducers: {
    setCurrentScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    setSites: (state, action) => {
      state.sites = action.payload;
    },
    setSiteHours: (state, action) => {
      state.siteHours = action.payload;
    },
    setReloadPaymentPage: (state, action) => {
      state.reloadPaymentPage = action.payload;
    },
  },
});

export const {
  setCurrentScreen,
  setSites,
  setSiteHours,
  setReloadPaymentPage,
} = screenReducer.actions;
